import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Dropdown, Popover } from "antd";

export function FooterComponent() {
  const location = useLocation();

  return (
    <>
      <footer
        style={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          backgroundColor: "#000a4f",
          color: "white",
          // clipPath: "ellipse(85% 90% at 50% 100%)",
          zIndex: 1000,
        }}
        className="d-xl-none"
      >
        {/* Footer icons and text */}
        {/* <ul className="nav nav-line-tabs border-transparent fs-5 fw-bold row d-flex justify-content-evenly align-items-center  mt-5">
          <li className="nav-item col-3 text-center">
            <button
              className={`nav-link row ${
                activeTab === "Home" ? "text-white" : "text-muted"
              }`}
              style={{ backgroundColor: "transparent", borderBottom: "none" }}
              onClick={() => setActiveTab("Home")}
            >
              <i
                className={`fa-solid fa-house fa-lg col-12 pb-3 ${
                  activeTab === "Home" ? "text-white" : "text-muted"
                }`}
              ></i>
              <p className="col-12">Home</p>
            </button>
          </li>
          <li className="nav-item col-3 text-center">
            <button
              className={`nav-link row ${
                activeTab === "Attendance" ? "text-white" : "text-muted"
              }`}
              style={{ backgroundColor: "transparent", borderBottom: "none" }}
              onClick={() => setActiveTab("Attendance")}
            >
              <i
                className={`fa-solid fa-clipboard-user fa-lg col-12 pb-3 ${
                  activeTab === "Attendance" ? "text-white" : "text-muted"
                }`}
              ></i>
              <p className="col-12">Attendance</p>
            </button>
          </li>
          <li className="nav-item col-3 text-center">
            <button
              className={`nav-link row ${
                activeTab === "Leaves" ? "text-white" : "text-muted"
              }`}
              style={{ backgroundColor: "transparent", borderBottom: "none" }}
              onClick={() => setActiveTab("Leaves")}
            >
              <i
                className={`fa-solid fa-calendar-check fa-lg col-12 pb-3 ${
                  activeTab === "Leaves" ? "text-white" : "text-muted"
                }`}
              ></i>
              <p className="col-12">Leaves</p>
            </button>
          </li>
          <li className="nav-item col-3 text-center">
            <button
              className={`nav-link row ${
                activeTab === "LeaveSummary" ? "text-white" : "text-muted"
              }`}
              style={{ backgroundColor: "transparent", borderBottom: "none" }}
              onClick={() => setActiveTab("LeaveSummary")}
            >
              <i
                className={`fa-solid fa-clipboard-user fa-lg col-12 pb-3 ${
                  activeTab === "LeaveSummary" ? "text-white" : "text-muted"
                }`}
              ></i>
              <p className="col-12">Summary</p>
            </button>
          </li>
        </ul> */}

        <div className="container-fluid my-5 fs-6">
          <div className="row text-center pt-2">
            <div className="col">
              <Link to="/Profile">
                <i
                  className={`fa-solid fa-house fa-lg ${location.pathname == "/Profile"
                    ? "text-white"
                    : "text-gray-600"
                    }`}
                ></i>
                <div
                  className={
                    location.pathname == "/Profile"
                      ? "text-white"
                      : "text-gray-600"
                  }
                >
                  Home
                </div>
              </Link>
            </div>
            <div className="col">
              <Link to="/Team">
                <i
                  className={`fa-solid fa-people-group fa-lg ${location.pathname == "/Team"
                    ? "text-white"
                    : "text-gray-600"
                    }`}
                ></i>
                <div
                  className={
                    location.pathname == "/Team"
                      ? "text-white"
                      : "text-gray-600"
                  }
                >
                  Teams
                </div>
              </Link>
            </div>
            <div className="col">
              <Link to="/Leaves">
                <i
                  className={`fa-solid fa-calendar-check fa-lg ${location.pathname == "/Leaves"
                    ? "text-white"
                    : "text-gray-600"
                    }`}
                ></i>
                <div
                  className={
                    location.pathname == "/Leaves"
                      ? "text-white"
                      : "text-gray-600"
                  }
                >
                  Leaves
                </div>
              </Link>
            </div>
            <div className="col align-items-center d-flex justify-content-center">
              <Link to="/Menu">
                <i
                  className={`fa-solid fa-bars fs-4x ${location.pathname == "/Menu"
                    ? "text-white"
                    : "text-gray-600"
                    }`}
                ></i>
                <div
                  className={
                    location.pathname == "/Menu"
                      ? "text-white"
                      : "text-gray-600"
                  }
                ></div>
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
